import { useEffect, useRef, useState, useReducer } from 'react'
import { getCWPEnvironmentForURL, APIENDPOINT } from './common-utils'

export const useFetch = url => {
  const cache = useRef({})

  const initialState = {
    status: 'idle',
    error: null,
    data: [],
  }
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'FETCHING':
        return { ...initialState, status: 'fetching' }
      case 'FETCHED':
        return { ...initialState, status: 'fetched', data: action.payload }
      case 'FETCH_ERROR':
        return { ...initialState, status: 'error', error: action.payload }
      default:
        return state
    }
  }, initialState)
  useEffect(() => {
    let cancelRequest = false
    if (!url || !url.trim()) return

    const fetchData = async () => {
      dispatch({ type: 'FETCHING' })
      if (cache.current[url]) {
        const data = cache.current[url]
        dispatch({ type: 'FETCHED', payload: data })
      } else {
        try {
          const response = await fetch(url)
          const data = await response.json()
          cache.current[url] = data
          if (cancelRequest) return
          dispatch({ type: 'FETCHED', payload: data })
        } catch (error) {
          if (cancelRequest) return
          dispatch({ type: 'FETCH_ERROR', payload: error.message })
        }
      }
    }

    fetchData()

    return function cleanup() {
      cancelRequest = true
    }
  }, [url])
  return state
}

/**
 * Gets the location the user is accessing the site from using the
 * one trust location script
 * @returns {{Boolean}} true if in California and on activated site
 */
export const usePrivacyOptOutCheck = () => {
  const [showOptOut, setShowOptOut] = useState(false)

  useEffect(() => {
    window.geofeed = options => {
      const country = options.country.toString()
      const state = options.state.toString()
      if (state === 'CA' && country === 'US') {
        setShowOptOut(true)
      }
    }
    // Call geo-location JSON service
    const json = document.createElement('script')
    json.setAttribute(
      'src',
      'https://geolocation.onetrust.com/cookieconsentpub/v1/geo/location/geofeed'
    )
    document.head.appendChild(json)
  }, [])

  return showOptOut
}

export const useOneTrustBundles = () => {
  const env = getCWPEnvironmentForURL(window.location.href)
  const endpointUrl = `${
    APIENDPOINT(env).base
  }halapi/resourcebundles/ampmicrosites.globalnavigation`
  const { status, data, error } = useFetch(endpointUrl)
  if (error) return {}
  return {
    oneTrustLabel: status === 'fetched' ? data.bundles && data.bundles.default['one-trust'] : null,
    oneTrustUrl:
      status === 'fetched' ? data.bundles && data.bundles.default['one-trust-url'] : null,
  }
}

export const useMobile = () => {
  const [isMobileSize, setIsMobileSize] = useState(window.innerWidth < 768)

  useEffect(() => {
    const handleWindowSizeChange = () => {
      setIsMobileSize(window.innerWidth < 768)
    }
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])
  return isMobileSize
}
